export const playlistActions = {
  LOADING: "LOADING",
  ERROR: "ERROR",
  GET_ALL_PLAYLISTS: "GET_ALL_PLAYLISTS",
  GET_PLAYLIST: "GET_PLAYLIST",
  ADD_PLAYLIST: "ADD_PLAYLIST",
  DELETE_PLAYLIST: "DELETE_PLAYLIST",
  ADD_VIDEO_TO_PLAYLIST: "ADD_VIDEO_TO_PLAYLIST",
  DELETE_VIDEO_FROM_PLAYLIST: "DELETE_VIDEO_FROM_PLAYLIST",
};
